import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessSystemService } from '../core/services/access-system.service';
import { firstValueFrom } from 'rxjs';

export const sistemaGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const systemId = route.data['systemId'];
  const sistemas = inject(AccessSystemService);
  const sistema = await firstValueFrom(sistemas.getUserSystems(systemId));

  if (sistema) return true;
  else {
    router.navigate(['unauthorized']);
    return false;
  }
};
